import { useEffect, useState } from 'react';
// Current time in ms, re-rendered right after every whole second so stopwatches tick in step.
export const useNow = () => {
    const [now, setNow] = useState(() => Date.now());
    useEffect(() => {
        let timer;
        const schedule = () => {
            timer = window.setTimeout(() => {
                setNow(Date.now());
                schedule();
            }, 1000 - (Date.now() % 1000) + 5);
        };
        schedule();
        return () => window.clearTimeout(timer);
    }, []);
    return now;
};
